<template>
  <v-row justify="center">
    <v-col v-for="(type, i) in currentTypes" :key="i" cols="3" sm="3">
      <v-tooltip open-delay="500" top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="flex-center">
            <v-checkbox dense v-model="types" :value="type">
              <template v-slot:label>
                <IconShootingType :type="type" />
              </template>
            </v-checkbox>
          </div>
        </template>
        <span>{{ translatedTypes(type) }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import IconShootingType from '@/components/common/atoms/IconShootingType'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'ShootingsFilterType',

  components: {
    IconShootingType
  },

  computed: {
    types: {
      get: function() {
        return this.$store.state.researchShooting.current.types
      },
      set: function(types) {
        this.$store.commit('RESEARCH_TYPES', types)
      }
    },
    ...mapState({
      userOptions: state => state.userOptions
    }),

    ...mapGetters('usersConfig', {
      typesForUser: 'typesForUser'
    }),

    currentTypes() {
      return this.typesForUser
    }
  },

  methods: {
    translatedTypes(type) {
      const typeMapping = {
        STANDARD: 'shootings.types.standard',
        VIDEO: 'shootings.types.videos',
        INSPECTION: 'shootings.types.inspection',
        INSPECTION_REPAIR_ORDER: 'shootings.types.inspectionRepairOrder'
      }

      return this.$t(typeMapping[type] || '')
    }
  }
}
</script>

<style lang="sass" scoped>
.flex-center
  height: 20px
  display: flex
  justify-content: center
  align-items: center
</style>
